module.exports = __webpack_public_path__ + "static/img/son4_active.ffd7d29d.png";